import React from "react";
import { useEffect } from "react";
import { urlAssetsCustom } from "utils/common";

 

const RulesPage = (props) => {
  useEffect(() => {
 
 window.scrollTo({ top: 0, behavior: "smooth" });

 
 }, []);
  return (
     < div className="container rule-page">
      <div className="box-warrper">
        <div className="box-inner">

      <img
          className="title-rule"
          src={urlAssetsCustom("assets/img/title-rule.png")}
          alt=""
        />
      <div className="container rules">
       <div className="imai"></div>
        <p><strong>Tên chương trình:</strong></p>
<p>Chương trình khuyến mãi Mua Sunlight rửa chén và lau sàn tặng dụng
cụ dọn dẹp & Voucher bTaskee
</p>
<p><strong>Các tỉnh có hoạt động của bTaskee:</strong></p>
<p>TP.HCM, Hà Nội, Đà Nẵng, Lâm Đồng, Đồng Nai,
Huế, Hải Phòng, Khánh Hòa, Cần Thơ.</p>
<p><strong>Phạm vi áp dụng chương trình khuyến mãi của Sunlight:</strong></p>
<p>Thành phố Hà Nội, Cao Bằng, Tuyên Quang, Điện Biên, Lai Châu, Sơn La, Lào Cai, Thái
Nguyên, Lạng Sơn, Quảng Ninh, Bắc Ninh, Phú Thọ, Thành phố Hải Phòng, Hưng Yên, Ninh
Bình, Thanh Hóa, Nghệ An, Hà Tĩnh, Quảng Trị, Thành phố Huế, Thành phố Đà Nẵng, Quảng
Ngãi, Gia Lai, Khánh Hòa, Đắk Lắk, Lâm Đồng, Đồng Nai, Thành phố Hồ Chí Minh, Tây
Ninh, Đồng Tháp, Vĩnh Long, An Giang, Thành phố Cần Thơ, Cà Mau.</p>

<p><strong>Hình thức khuyến mãi:</strong></p><p>Mua sản phẩm Sunlight rửa chén và lau sàn được tặng dụng cụ
dọn dẹp & Voucher bTaskee.</p>

<p><strong>Thời gian áp dụng:</strong></p> <p>Từ <b>01/12/2025</b> đến <b>31/03/2026</b>.</p>

<p><strong>Đối tượng tham gia:</strong></p><p>Khách hàng mua các sản phẩm Sunlight nước rửa chén và lau sàn
thuộc combo "Sạch nhà bóng loáng" chương trình khuyến mãi Tết tại các cửa hàng tạp hóa
trong phạm vi chương trình.</p>

<p><strong>Cơ cấu quà tặng:</strong></p>

<p>Voucher dịch vụ bTaskee trị giá <b>30.000 VNĐ</b>.</p>
<p>Tổng số lượng: <b>150.000 voucher</b>.</p>


<p><strong>Cách thức tham gia:</strong></p>
<p>
  Tham gia cùng chương trình Tết Sunlight với 3 bước:</p>
  <ul>
<li><b>Bước 1:</b> Khách hàng mua các sản phẩm Sunlight nước rửa chén và lau sàn thuộc combo
"Sạch nhà bóng loáng" chương trình khuyến mãi Tết tại các cửa hàng tạp hóa trong phạm vi
chương trình</li>
<li><b>Bước 2:</b> Quét mã QR để truy cập trang chủ chương trình, nhập thông tin để nhận quà</li>
<li><b>Bước 3:</b> Sau khi xác thực OTP, khách hàng nhận voucher bTaskee trị giá 30.000 VND qua
tin nhắn và có thể tự sử dụng voucher trong ứng dụng bTaskee.</li></ul>

<p><strong>Quy định chung về Voucher bTaskee:</strong></p>
<ul>
  <li>Ưu đãi áp dụng dành cho khách hàng của Sunlight
</li><li>Ưu đãi áp dụng cho tất dịch vụ trên bTaskee
</li><li> Mỗi username chỉ sử dụng ưu đãi 1 lần
</li><li> Giải thưởng không có giá trị quy đổi thành tiền mặt.
</li><li> Người nhận thưởng phải tuân thủ quy định bảo hành, chính sách bảo hành của nhà sản
xuất. Nếu có thắc mắc về cách sử dụng hoặc bất kỳ khiếu nại nào liên quan đến Voucher
bTaskee, vui lòng liên hệ bTaskee qua email <b>support@bTaskee.com</b> hoặc <b>hotline
1900636736</b> để được giải quyết</li>
</ul>
<p><strong>LƯU Ý QUAN TRỌNG</strong></p>
<ul>
  <li>Trong trường hợp có sự thay đổi về thể lệ chương trình cũng như thời gian tổ chức, BTC sẽ
thông báo công khai trên Facebook Sunlight.
</li><li> Mỗi <b>số điện thoại</b> chỉ được đổi quà <b>1 lần duy nhất</b> trong suốt chương trình.
</li><li> Mỗi ngày có <b>2.000 voucher</b> được phát. Nếu chưa phát hết trong ngày, lượng voucher còn
lại của ngày hôm trước sẽ được cộng dồn sang ngày hôm sau, cho đến hết voucher hoặc
hết thời gian của chương trình (tùy điều kiện nào đến trước).
</li><li> Trường hợp hết voucher trong ngày, vui lòng quay lại vào ngày hôm sau để nhận quà.
</li><li> Thông tin liên hệ nhà sản xuất Sunlight – Công ty TNHH Quốc tế Unilever Việt Nam hotline 02838236651
</li></ul>
      </div> 
      <div className="imai bottom"></div>
        </div>
      </div>
    </div>
  );
};
export default RulesPage;
